import Error404 from './404'
import Error500 from './500'
import BlankPage from './BlankPage'

const routes = [
  {
    path: '/blank-page',
    name: 'blank-page',
    component: BlankPage
  }, {
    path: '/404',
    name: '404',
    component: Error404
  }, {
    path: '/500',
    name: '500',
    component: Error500
  }
]

export { Error404, Error500, BlankPage, routes }



// WEBPACK FOOTER //
// ./src/components/modules/common/index.js